"use client";

import { Button, cn } from "@saridana-core/react-ui-kit";
import { TButtonLink } from "@shared/types";
import { SectionHeading } from "@shared/ui";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function ArticleHeadingSection({ title, navLinks }: { title?: string; navLinks?: TButtonLink[] }) {
  const path = usePathname();

  return (
    <section className="pt-20 md:pt-[120px] pb-0 relative overflow-hidden bg-white">
      <div className="container relative">
        {title && <SectionHeading className="text-left" title={title} titleClassName="w-full max-w-full" />}

        {navLinks && navLinks.length > 0 && (
          <div className="flex gap-3 w-full mt-7 sm:mt-9 md:mt-10 flex-nowrap whitespace-nowrap overflow-x-auto">
            {navLinks.map((navLink, index) => {
              return (
                <Button
                  key={"article-navlink-" + index}
                  asChild
                  variant="ghost"
                  className={cn(
                    "text-xl font-semibold rounded-3xl px-6 h-12",
                    path === navLink?.href ? "bg-primary-50 text-primary-600" : "text-gray-600 bg-gray-50",
                  )}
                >
                  <Link href={navLink?.href} target={navLink?.target || "_self"}>
                    {navLink?.text}
                  </Link>
                </Button>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
